module.exports = __webpack_public_path__ + "img/a11y-stability-2_jp.9ae07ad.jpg";